import { NgModule } from '@angular/core';

import { ApplicationInsightsService } from './application-insights.service';

@NgModule({
  providers: []
})
export class ApplicationInsightsModule {
  // Injecting ApplicationInsightsService to enable it.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(applicationInsightsService: ApplicationInsightsService) {
    // inject ApplicationInsightsService to create and initialize it.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  }
}
